import React from "react";

function TermsPage() {
  return (
    <div className="bg-gray-50 text-gray-900 min-h-screen flex flex-col">
      {/* Hero Section */}
      <header className="relative bg-gradient-to-r from-blue-500 to-purple-600 text-white text-center py-10 px-6 shadow-lg mt-[70px]">
        <h1 className="text-3xl md:text-5xl font-extrabold tracking-wide">Terms & Conditions</h1>
        <p className="text-xl mt-3 max-w-2xl mx-auto">Welcome to our website. By accessing or using our services, you agree to
        comply with and be bound by the following terms and conditions.</p>
        <div className="!absolute inset-0 bg-opacity-20 bg-black"></div>
      </header>

      {/* Content Section */}
      <div className="max-w-4xl mx-auto p-8 bg-white shadow-lg rounded-lg mt-10">
        <h2 className="text-[22px] font-semibold mb-4 mt-2 text-[#565555]">Acceptance of this Agreement</h2>
        <p className="text-sm leading-relaxed text-[#2e3d49]">By clicking on the ‘ <strong>SIGNUP</strong>‘ option or ‘ <strong>I’m Interested, Tell me more</strong>‘

option, the participant (“ <strong>You</strong>” or “ <strong>Your</strong>“) agrees to the Terms and

Conditions, obligations, representations, warranties, and agreements contained herein (the “

<strong>Agreement</strong>“). In the event, You are not willing to accept the Agreement, You shall not

be authorized or allowed to proceed further to view or use in any manner any content, information,

courseware, products and services (“ <strong>Services</strong> “) published, available or provided on <a href="https://yslearn.in">www.yslearn.in</a> (the “ <strong>Website</strong>

“), which is owned, maintained and monitored by Smik Systems (OPC) Private Limited (“

<strong>Us</strong> “, “ <strong>We</strong> ” or “ <strong>Our</strong> “).

</p>
        <h2 className="text-[22px] font-semibold mb-4 mt-2 text-[#565555]">User ID and Password</h2>
        <p className="text-sm leading-relaxed text-[#2e3d49]">By entering into this Agreement, You acknowledge and agree that Your user ID and password (“

<strong>Participant Account</strong>“) is for Your exclusive use only. Use or sharing of Your

Participant Account with another user is not permitted and is cause for the immediate blocking of Your

access to the Website, the Services, and the Content, the Courseware, and termination of this Agreement.

</p><br/>
<p className="text-sm leading-relaxed text-[#2e3d49]">You agree that You are solely responsible for maintaining the confidentiality of Your Participant Account

        and for all activities that occur under it. You agree to immediately notify our a 

         <a href="mailto:smiklearncbe@gmail.com" target="_blank" rel="noopener noreferrer" style={{color:"blue"}}> Help and
          Support Team</a> if You become aware of or have reason to believe that there is any unauthorized use

        of Your Participant Account. You also agree to take all reasonable steps to stop such unauthorized use

        and to cooperate with Us in any investigation of such unauthorized uses. We shall not under any

        circumstances be held liable for any claims related to the use or misuse of Your Participant Account due

        to the activities of any third party outside of our control or due to Your failure to maintain the

        confidentiality and security of Your Participant Account.

      </p>
        <h2 className="text-[22px] font-semibold mb-4 mt-2 text-[#565555]">Content and Courseware</h2>
        <p className="text-sm leading-relaxed text-[#2e3d49]">As a part of our Services offered through our Website, We shall grant you access to our content,

courseware, practice tests, and other information, documents, and data which may be in audio, video,

written, graphic, recorded, photographic, or any machine-readable format in relation to the specific

certification training course You have registered for (“ <strong>Content and Courseware</strong>“).</p>
        <h2 className="text-[22px] font-semibold mb-4 mt-2 text-[#565555]">Usage of the Website and Services</h2>
        <p className="text-sm leading-relaxed text-[#2e3d49]">We grant you a personal, restricted, non-transferable, non-exclusive, and revocable license to use the

Website, the Services, and the Content and Courseware offered through the Website till the time the

completion of the certification training course that You have enrolled for or the termination of this

Agreement according to the Terms and Conditions set forth herein, whichever is earlier. The Services and

the Content and Courseware are provided solely for Your personal and non-commercial use to assist you in

completing the certification training course You have registered for (“ <strong>Restricted

  Purpose</strong>“).</p><br />
        <h3 className="text-[22px] font-semibold mb-4 mt-2 text-[#565555]">Entire Agreement</h3>
        <p className="text-sm leading-relaxed text-[#2e3d49]">This Agreement, along with the Privacy Policy, Refund Policy, Terms of Use, Cookie Policy and any

additional guidelines, rules, and/or disclaimers posted on the Website constitutes the entire agreement

governing Your use of our Website and supersedes any prior agreements, if any, relating to any matter

dealt within this Agreement.</p>
        
     </div>

      
    </div>
  );
}

export default TermsPage;
